<div class="details-page">
  <section class="details-panel">
    <div class="panel-header" *ngIf="route.snapshot.queryParams['id']">
      <button
        type="button"
        class="details-back page-title"
        (click)="navigateToList()"
      >
        <mat-icon aria-hidden="false">arrow_back</mat-icon>
        <span>Annotations / {{ data?.typeId }}</span>
      </button>
    </div>

    <div class="details-body">
      <mat-tab-group>
        <mat-tab label="Main Information">
          <app-annotatio-type-main-info
            (mainInformation)="getmainForminfo($event)"
            [annotationData]="data"
          ></app-annotatio-type-main-info>
        </mat-tab>
        <mat-tab label="Add Comment">
          <app-annotatio-type-comment-info
            (commentInformation)="getCommentFormInfo($event)"
            [annotationData]="data"
          ></app-annotatio-type-comment-info>
        </mat-tab>
      </mat-tab-group>
    </div>

    <div class="panel-footer">
      <button mat-stroked-button (click)="navigateToList()" class="cancel-btn">
        {{ "Cancel" }}
      </button>
      <button [disabled]="!ability.canEdit(ability.subjects.Annotation)" type="submit" mat-flat-button color="primary" (click)="save()">
        {{ "Save" }}
      </button>
    </div>
  </section>
</div>
